import { routes } from './routes-generated';

import { GetWithHook, GetWithPromise, PostWithPromise } from '../modules/api/client';

export function ContactForm2EndpointGetHook(
    param_name: string, 
    param_email: string, 
    param_message: string, 
) {
    return GetWithHook(routes.ContactForm, {
        name: param_name, 
        email: param_email, 
        message: param_message, 
    });
}

export function ContactForm2EndpointGetPromise(
    param_name: string, 
    param_email: string, 
    param_message: string, 
) {
    return GetWithPromise(routes.ContactForm, {
        name: param_name, 
        email: param_email, 
        message: param_message, 
    });
}

export function ContactForm2EndpointPostPromise(
    param_name: string, 
    param_email: string, 
    param_message: string, 
) {
    return PostWithPromise(routes.ContactFormPost, {
        name: param_name, 
        email: param_email, 
        message: param_message, 
    });
}

